import { IonButton,IonText } from "@ionic/react";
import React from "react";
import { User } from "../models/data";
import { translation } from "../models/translation";
import { createCredit, createDonation } from "../services/donate_service";
import { confirmPaymentInfo } from "../services/pmt_service";
import { ymd } from "../utlities/ymd";


declare global {
    interface Window {
        IframeCheckoutHandler: any;
    }
}

interface PmCompProps {
    totalAmount:any,
    amount: any,
    pmtMethod: any,
    type: string,
    reloading:boolean,
    donateData: any,
    commition: any,
    method: any,
    user: User
    transactionId:any,
    version:any
    siteText:any
}

const PayComponent: React.FC<PmCompProps> = (props) => {
    const siteText=translation()
    const date = new Date();
    let month = date.getMonth() + 1;
    let day = date.getDate();

    var paymentMethodConfigurationId = props.pmtMethod;

    // Set here the id of the HTML element the payment iframe should be appended to.
    var containerId = 'payment-form';
    var handler = window.IframeCheckoutHandler(paymentMethodConfigurationId);
    document.getElementById('payment-form')!.innerHTML = "";
    handler.setValidationCallback(
        function (validationResult: any) {
            // Reset payment errors
            let errorList: any = document.querySelector('#payment-errors')!;
            errorList.innerHTML = '';

            if (validationResult.success) {
                //Create the order within the shop and eventually update the transaction.
                //setSubmitting(true);
                if (props.type === 'credit') {
                    createCredit({
                        title: `${props.user.firstName}_${month}_${day}`,
                        status: "publish",
                        acf: {
                            status: "pending",
                            amount: (+props.amount-props.donateData.tip),
                            tip:+props.donateData.tip,
                            credit_method: props.method
                        }
                    }).then(
                        m => {
                            if (m!.message) {
                                confirmPaymentInfo(props.user,props.totalAmount,props.siteText.userTransactionCredit,props.transactionId,m?.message.id,props.version).then(m=>{
                                    if(m!.message){
                                        handler.submit();
                                    }
                                })
                            } else {
                                console.log(m?.error)
                                alert('something went wrong')
                            }
                        }
                    )
                } else {
                    let resp = createDonation({
                        title: `${props.user.firstName}_${month}_${day}`,
                        status: "publish",
                        acf: {
                            status: "pending",
                            beneficiary: props.donateData.pickOrg,
                            beneficiary_type:props.donateData.beneficiary_type,
                            alternative_benefiary: props.donateData.altOrg,
                            anonymous: `${props.donateData.anom}`,
                            amount: +props.amount,
                            tip:+props.donateData.tip,
                            language:props.donateData.language?props.donateData.language:'',
                            commission: props.commition,
                            date: ymd(props.donateData.date),
                            donation_method: props.method,
                            message: props.donateData.message,
                            frequency: props.donateData.freq
                        }
                    }).then(
                        m => {
                            if (m!.message) {
                                confirmPaymentInfo(props.user,props.totalAmount,props.siteText.userTransactionDonation,props.transactionId,m?.message.id,props.version).then(m=>{
                                    if(m!.message){
                                        handler.submit();
                                    }
                                })
                            } else {
                                alert('something went wrong')
                            }
                        }
                    )

                }

            } else {
                // Display errors to customer
                validationResult.errors.foreach((index: any, errorMessage: any) => {
                    errorList.append('<li>' + errorMessage + '</li>')
                });
            }
        });
    //Set the optional initialize callback
    handler.setInitializeCallback(function () {
        //Execute initialize code
    });
   //Set the optional height change callback
    handler.setHeightChangeCallback(function (height: any) {
        //Execute code
        return 300;
    });
    handler.create(containerId);

    const payHandler = () => {
        handler.validate();

    }

    return (
        <>
            <IonButton disabled={ props.reloading?true:false || !props.pmtMethod} id="pay-button" onClick={payHandler}><IonText color='light'>{props.type === "credit" ? siteText.creditAccountPaymentPrimary : siteText.donateDirectlypayPrimary}</IonText></IonButton>
        </>
    )
}

export default PayComponent;